import styled from "styled-components";
import theme from "../../constants/globalStyles/theme.json";

const { spacing, radius, breakpoints } = theme;

export const Container = styled.div`
  display: flex;
  padding: ${spacing.space24};
  padding-bottom: 280px;
  gap: ${spacing.space64};
  max-width: 1440px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.l}) {
    flex-direction: column;
    gap: ${spacing.space32};
  }
`;

export const ContactInformation = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #e6e0ca;
  padding: ${spacing.space32};
  border-radius: ${radius.large};
  max-height: 480px;
  max-width: 600px;
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.1);

  @media (max-width: ${breakpoints.s}) {
    max-height: 100%;
  }
`;
